import { render, staticRenderFns } from "./ex-list.vue?vue&type=template&id=471f6697&scoped=true&"
import script from "./ex-list.vue?vue&type=script&lang=js&"
export * from "./ex-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-list.vue?vue&type=style&index=0&id=471f6697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f6697",
  null
  
)

export default component.exports